import { catalog } from 'core';
import { Slide, slideSizeCSS } from './Carousel.components.styles';
import type { StageProps } from './Carousel.components.d';
import type { CSSProperties, Dispatch, SetStateAction } from 'react';

type TCarouselSlide = Pick<StageProps, 'children'> & {
  customProps?: Record<string, unknown>;
  slugname?: string;
  setSelectedImageIndex?: Dispatch<SetStateAction<number>>;
};

const CarouselSlide = ({
  children,
  customProps,
  slugname,
  setSelectedImageIndex,
  ...props
}: TCarouselSlide) => {
  const {
    controls,
    index,
    state = {},
  } = props as Pick<StageProps, 'controls' | 'state'> & {
    index: number;
  };
  const { category } = catalog.hooks.useLocationQueryOptions();

  if (Object.keys(state).length === 0) {
    return null;
  }

  const { itemsPerPage, selectable, selectedItemIndex } = state;
  const { toggleSelected } = controls;
  const handleSelect = selectable ? { onClick: toggleSelected } : {};
  const size = itemsPerPage === 1 ? '100%' : `${100 / itemsPerPage}%`;

  if (setSelectedImageIndex) {
    setSelectedImageIndex(state.page);
  }

  const getItemOpacity = (itemIndex: number, selectedItem?: number) => {
    if (selectedItem !== undefined) {
      return itemIndex === selectedItem ? '100' : '25';
    }

    return '100';
  };

  const selectedIndexProps = () => {
    if (slugname) {
      return {
        'data-active': category === slugname || '',
        'data-opacity': category ? (category === slugname ? '100' : '25') : '100',
      };
    }

    return {
      'data-active': index === selectedItemIndex,
      'data-opacity': selectable ? getItemOpacity(index, selectedItemIndex) : '100',
    };
  };

  const sliderProps = {
    ...selectedIndexProps(),
    'data-index': index,
    'data-selectable': selectable,
    'data-items': itemsPerPage,
    'data-testid': 'slide',
    style: { [slideSizeCSS]: `${size}` } as CSSProperties,
    ...handleSelect,
    ...(customProps && { ...customProps }),
  };

  return <Slide {...sliderProps}>{children}</Slide>;
};

export default CarouselSlide;
